import script from "./GetInTouchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GetInTouchPage.vue?vue&type=script&setup=true&lang=js"

import "./GetInTouchPage.vue?vue&type=style&index=0&id=7b19f26c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b19f26c"]])

export default __exports__